/*
 * Sidebar size guide behaviour.
 *
 * Lives in its own asset rather than inline in snippets/sidebar-size-guide.liquid
 * because the quick view popup injects its markup with innerHTML, and scripts
 * inserted that way never execute. Loading it globally lets the MutationObserver
 * below pick up the quick view's markup once the popup renders.
 */
(function () {
  if (window.__ssgInit) return;
  window.__ssgInit = true;

  function moveDrawersToBody() {
    var drawers = document.querySelectorAll('[data-ssg-drawer]');

    drawers.forEach(function (drawer) {
      if (drawer.parentElement === document.body) return;

      // The quick view re-renders its markup on every open, so a drawer left
      // behind from the previous product would win getElementById on the next.
      if (drawer.id) {
        for (var i = 0; i < drawers.length; i++) {
          if (
            drawers[i] !== drawer &&
            drawers[i].id === drawer.id &&
            drawers[i].parentElement === document.body
          ) {
            drawers[i].parentElement.removeChild(drawers[i]);
          }
        }
      }

      document.body.appendChild(drawer);
    });
  }

  moveDrawersToBody();

  function normalizeSize(value) {
    return (value || '').trim().toLowerCase();
  }

  function findSizeSwatchLabel(optionName) {
    var target = normalizeSize(optionName);
    if (!target) return null;

    var labels = document.querySelectorAll('label.swatch-label');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var input = label.querySelector('input[name]');
      var optionText = label.querySelector('.swatch-option-name');

      if (input && normalizeSize(input.getAttribute('name')) === target) return label;
      if (optionText && normalizeSize(optionText.textContent) === target) return label;
    }

    return null;
  }

  function findNativeSizeLabelWrapper(optionName) {
    var target = normalizeSize(optionName);
    if (!target) return null;

    var options = document.querySelectorAll('.product__option');
    for (var i = 0; i < options.length; i++) {
      var wrapper = options[i].querySelector('.product__label-wrapper');
      var labelEl = options[i].querySelector('.product__label');
      if (!wrapper || !labelEl) continue;
      if (wrapper.querySelector('[data-ssg-trigger]')) return wrapper;

      var heading = (labelEl.textContent || '').split(':')[0];
      if (normalizeSize(heading) === target) return wrapper;
    }

    return null;
  }

  // Both links share one box, so they read as a pair sitting next to the size
  // heading rather than as two things at opposite ends of the row. Appended in
  // the order the wraps appear, which is the order the blocks render in.
  function triggerGroup(container) {
    var group = container.querySelector('.ssg-trigger-group');
    if (!group) {
      group = document.createElement('div');
      group.className = 'ssg-trigger-group';
      container.appendChild(group);
    }
    return group;
  }

  function placeTriggersInSwatchLabels() {
    document.querySelectorAll('.ssg-wrap[data-ssg-size-option-name]').forEach(function (wrap) {
      var trigger = wrap.querySelector('[data-ssg-trigger]');
      if (!trigger) return;

      if (trigger.closest('.ssg-trigger-group')) {
        wrap.classList.add('ssg-wrap--trigger-placed');
        return;
      }

      if (wrap.getAttribute('data-ssg-place-inline') !== 'true') return;

      var optionName = wrap.getAttribute('data-ssg-size-option-name');
      var nativeWrapper = findNativeSizeLabelWrapper(optionName);
      if (nativeWrapper) {
        trigger.classList.add('ssg-trigger--inline');
        nativeWrapper.classList.add('product__label-wrapper--with-ssg');
        triggerGroup(nativeWrapper).appendChild(trigger);
        wrap.classList.add('ssg-wrap--trigger-placed');
        moveDrawersToBody();
        return;
      }

      var label = findSizeSwatchLabel(optionName);
      if (!label) return;

      var header = label.closest('.ssg-swatch-header');
      if (!header) {
        header = document.createElement('div');
        header.className = 'ssg-swatch-header';
        label.parentNode.insertBefore(header, label);
        header.appendChild(label);
        label.classList.add('swatch-label--with-ssg');
      }

      trigger.classList.add('ssg-trigger--inline');
      triggerGroup(header).appendChild(trigger);
      wrap.classList.add('ssg-wrap--trigger-placed');
      moveDrawersToBody();
    });
  }

  function handleSsgOpenClick(e) {
    var openBtn = e.target.closest('[data-ssg-open]');
    if (!openBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var drawer = document.getElementById(openBtn.getAttribute('data-ssg-open'));
    if (drawer) openDrawer(drawer);
  }

  placeTriggersInSwatchLabels();

  if (window.MutationObserver) {
    var ssgPlacementObserver = new MutationObserver(function () {
      placeTriggersInSwatchLabels();
    });
    // On the product page the block ships in the initial markup, so the whole
    // body is watched as before. Everywhere else only the quick view popup can
    // introduce it, so the observer stays scoped to that subtree.
    var ssgScope = document.querySelector('.ssg-wrap')
      ? document.body
      : document.querySelector('[data-quick-view-modal]');

    if (ssgScope) {
      ssgPlacementObserver.observe(ssgScope, { childList: true, subtree: true });
    }
    window.setTimeout(placeTriggersInSwatchLabels, 500);
    window.setTimeout(placeTriggersInSwatchLabels, 1500);
    window.setTimeout(placeTriggersInSwatchLabels, 3000);
  }

  // overflow:hidden stops the visitor scrolling the page, but not a script:
  // the desktop wheel is driven by Lenis, which scrolls programmatically, and
  // a clipped viewport still answers to that. So Lenis is paused for as long
  // as the drawer is open.
  function pauseBackgroundScroll(paused) {
    var lenis = window.lenis;
    if (!lenis) return;
    if (paused && typeof lenis.stop === 'function') lenis.stop();
    if (!paused && typeof lenis.start === 'function') lenis.start();
  }

  function openDrawer(drawer) {
    drawer.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    pauseBackgroundScroll(true);
    syncRadios(drawer);
    updateAtcState(drawer);
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.hidden = true;
    document.body.style.removeProperty('overflow');
    pauseBackgroundScroll(false);
  }

  function findOptionButton(wrapper, sizeValue) {
    var normalized = sizeValue.trim().toLowerCase();
    var btn = wrapper.querySelector('[data-option-value="' + sizeValue.replace(/"/g, '\\"') + '"]');
    if (btn) return btn;
    var match = null;
    wrapper.querySelectorAll('[data-option-value]').forEach(function (el) {
      var val = (el.getAttribute('data-option-value') || '').trim().toLowerCase();
      if (val === normalized) match = el;
    });
    return match;
  }

  function findStarAppsSizeInput(sizeValue) {
    var normalized = normalizeSize(sizeValue);
    var inputs = document.querySelectorAll('.swatch-single input, .swatch-view input, [class*="swatch"] input[type="radio"]');

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (normalizeSize(input.value) === 'true') continue;
      if (normalizeSize(input.value) === normalized) return input;
      if (normalizeSize(input.getAttribute('data-value')) === normalized) return input;
    }

    var items = document.querySelectorAll('.swatch-view-item, .swatch-element, .swatch-view li, [class*="swatch-view"] li');
    for (var j = 0; j < items.length; j++) {
      var item = items[j];
      var itemInput = item.querySelector('input');
      if (itemInput && normalizeSize(itemInput.value) !== 'true' && normalizeSize(itemInput.value) === normalized) {
        return itemInput;
      }

      var itemValue = normalizeSize(
        item.getAttribute('data-value') ||
        item.getAttribute('data-option-value') ||
        item.getAttribute('aria-label') ||
        item.textContent
      );
      if (itemValue === normalized) {
        return itemInput || item;
      }
    }

    return null;
  }

  function getStarAppsSelectedSize() {
    var checked = document.querySelector(
      '.swatch-single input[type="radio"]:checked, .swatch-view input[type="radio"]:checked, .swatch-view-item.swatch-selected input, .swatch-view-item.selected input'
    );
    if (checked && checked.value && normalizeSize(checked.value) !== 'true') {
      return checked.value.trim();
    }

    var selectedItem = document.querySelector('.swatch-view-item.swatch-selected, .swatch-view-item.selected, .swatch-element.selected');
    if (selectedItem) {
      var input = selectedItem.querySelector('input');
      if (input && input.value && normalizeSize(input.value) !== 'true') return input.value.trim();
      var label = selectedItem.getAttribute('data-value') || selectedItem.getAttribute('aria-label') || selectedItem.textContent;
      if (label) return label.trim();
    }

    return '';
  }

  function applySize(sizeValue) {
    var wrapper = document.querySelector('.product__variants-wrapper');
    if (sizeValue) {
      var starTarget = findStarAppsSizeInput(sizeValue);
      if (starTarget) {
        if (starTarget.tagName === 'INPUT') {
          starTarget.checked = true;
          starTarget.dispatchEvent(new Event('change', { bubbles: true }));
          starTarget.dispatchEvent(new Event('click', { bubbles: true }));
        } else {
          starTarget.click();
        }
        return;
      }
    }

    if (!wrapper || !sizeValue) return;
    var btn = findOptionButton(wrapper, sizeValue);
    if (btn && !btn.disabled) { btn.click(); return; }
    var normalized = normalizeSize(sizeValue);
    wrapper.querySelectorAll('select[name^="options"]').forEach(function (select) {
      Array.prototype.forEach.call(select.options, function (opt) {
        if (normalizeSize(opt.value) === normalized && select.value !== opt.value) {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function getSelectedSize(drawer) {
    var starSize = getStarAppsSelectedSize();
    if (starSize) return starSize;

    var wrapper = document.querySelector('.product__variants-wrapper');
    if (!wrapper) return '';
    var idx = drawer.getAttribute('data-size-option-index');
    var select = wrapper.querySelector('select[data-index="option' + idx + '"]');
    if (select && select.value) return select.value.trim();
    var selected = wrapper.querySelector('[data-option-value].selected, .product__chip.selected');
    return selected ? (selected.getAttribute('data-option-value') || selected.textContent || '').trim() : '';
  }

  function syncRadios(drawer) {
    var size = getSelectedSize(drawer);
    if (!size) return;
    var normalized = size.toLowerCase();
    drawer.querySelectorAll('[data-ssg-radio]').forEach(function (radio) {
      radio.checked = radio.value.trim().toLowerCase() === normalized;
    });
  }

  function getProductForm() {
    return document.querySelector('[data-product-form]');
  }

  function updateAtcState(drawer) {
    var btn = drawer.querySelector('[data-ssg-atc]');
    var text = drawer.querySelector('[data-ssg-atc-text]');
    if (!btn || !text) return;

    var atcLabel = drawer.getAttribute('data-atc-label') || 'Add to cart';
    var soldOutLabel = drawer.getAttribute('data-sold-out-label') || 'Sold out';
    var radio = drawer.querySelector('[data-ssg-radio]:checked');
    var mainBtn = getProductForm() && getProductForm().querySelector('[data-add-to-cart]');

    if (!radio || radio.disabled) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      text.textContent = soldOutLabel;
      return;
    }

    var mainDisabled = mainBtn && (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true');
    btn.disabled = mainDisabled;
    btn.setAttribute('aria-disabled', mainDisabled ? 'true' : 'false');
    text.textContent = mainDisabled ? soldOutLabel : atcLabel;
  }

  function addToCartFromDrawer(drawer) {
    var btn = drawer.querySelector('[data-ssg-atc]');
    if (!btn || btn.disabled) return;

    var radio = drawer.querySelector('[data-ssg-radio]:checked');
    if (radio && !radio.disabled) applySize(radio.value);

    var form = getProductForm();
    var mainBtn = form && form.querySelector('[data-add-to-cart]');

    window.setTimeout(function () {
      if (!mainBtn || mainBtn.disabled) {
        updateAtcState(drawer);
        return;
      }
      if (form.requestSubmit) {
        form.requestSubmit(mainBtn);
      } else {
        mainBtn.click();
      }
      closeDrawer(drawer);
    }, 50);
  }

  function setUnit(drawer, useCm) {
    drawer.querySelectorAll('[data-ssg-unit-label="inch"]').forEach(function (el) {
      el.classList.toggle('is-active', !useCm);
    });
    drawer.querySelectorAll('[data-ssg-unit-label="cm"]').forEach(function (el) {
      el.classList.toggle('is-active', useCm);
    });
    drawer.querySelectorAll('[data-inch]').forEach(function (cell) {
      var val = useCm ? cell.getAttribute('data-cm') : cell.getAttribute('data-inch');
      if (val != null) cell.textContent = val;
    });
  }

  document.addEventListener('click', handleSsgOpenClick, true);
  document.addEventListener('touchend', handleSsgOpenClick, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ssg-open]')) return;
    if (e.target.closest('[data-ssg-close]')) {
      var active = e.target.closest('[data-ssg-drawer]');
      if (active) closeDrawer(active);
      return;
    }
    var atcBtn = e.target.closest('[data-ssg-atc]');
    if (atcBtn) {
      var drawerEl = atcBtn.closest('[data-ssg-drawer]');
      if (drawerEl) addToCartFromDrawer(drawerEl);
    }
  });

  document.addEventListener('change', function (e) {
    var drawer = e.target.closest('[data-ssg-drawer]');
    if (!drawer) return;
    if (e.target.matches('[data-ssg-unit-input]')) setUnit(drawer, e.target.checked);
    if (e.target.matches('[data-ssg-radio]') && e.target.checked) {
      applySize(e.target.value);
      window.setTimeout(function () { updateAtcState(drawer); }, 50);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-ssg-drawer].is-open').forEach(closeDrawer);
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.product__variants-wrapper select[name^="options"]')) return;
    document.querySelectorAll('[data-ssg-drawer].is-open').forEach(function (drawer) {
      syncRadios(drawer);
      updateAtcState(drawer);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.product__variants-wrapper [data-button]')) return;
    document.querySelectorAll('[data-ssg-drawer].is-open').forEach(function (drawer) {
      syncRadios(drawer);
      updateAtcState(drawer);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.swatch-single, .swatch-view, [class*="swatch-view"]')) return;
    document.querySelectorAll('[data-ssg-drawer].is-open').forEach(function (drawer) {
      window.setTimeout(function () {
        syncRadios(drawer);
        updateAtcState(drawer);
      }, 50);
    });
  });
})();
